// Scroll to Anchor
$(function() {
  $('a[href*=#]:not([href=#])').click(function() {
    if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        nav = $('header nav'),
        navHeight = nav.outerHeight(),
        $('html,body').animate({
          scrollTop: target.offset().top-navHeight+1
        }, 700);
        return false;
      }
    }
  });
});


// Center Nav
function centerNav() {
  $('header .menu-left').css('width', $('header .menu-right').width() );
  $('header .menu-center').addClass('centered');
};


// Scroll Gallery
if ($('.scroll-gallery').length) {
  $('.scroll-gallery').each(function() {
    const slider = this;
    let mouseDown = false;
    let startX, scrollLeft;

    let startDragging = function (e) {
      mouseDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };
    let stopDragging = function (event) {
      mouseDown = false;
    };

    slider.addEventListener('mousemove', (e) => {
      e.preventDefault();
      if(!mouseDown) { return; }
      const x = e.pageX - slider.offsetLeft;
      const scroll = x - startX;
      slider.scrollLeft = scrollLeft - scroll;
    });

    // add the event listeners
    slider.addEventListener('mousedown', startDragging, false);
    slider.addEventListener('mouseup', stopDragging, false);
    slider.addEventListener('mouseleave', stopDragging, false);
  });

  // is scrollable
  $.fn.isHScrollable = function () {
    return this[0].scrollWidth > this[0].clientWidth;
  };

}

// disable
function scrollGallery() {
  $('.scroll-gallery.scroll').each(function() {
    if ( !$(this).isHScrollable() ) {
      $(this).removeClass('scroll');
    }
  });
} 


// Lightbox
function toggleLightbox(e, type) {
  e.preventDefault();
  $('.lightbox-overlay[data-lightbox-type="' + type + '"]').toggleClass('show');
  $('html').toggleClass('overlay-active');
}
// open
$('a[data-type="lightbox"]').on('click',function(e, type){
  var type = $(this).data('lightbox-type');
  if (type == 'contact') {
    var showroom = $(this).data('showroom');
    console.log(showroom);
    var $lightbox = $('.lightbox-overlay[data-lightbox-type="contact"]');
    var loc = $(this).data('location');
    if (showroom == 'hide') {
      $lightbox.find('select').parent().parent('.globo-form-control').hide();
      $lightbox.find('select').val(loc); 
      $lightbox.find('select').change();
    };
    if (showroom) { // true
      $lightbox.find('select').parent().parent('.globo-form-control').hide(); 
      $lightbox.find('select').val(loc); 
      $lightbox.find('select').change();
      $lightbox.find('select')[0].dispatchEvent(new CustomEvent('change'));
      var manager = $(this).data('manager');
      $lightbox.find('h2').text('Contact Our ' + loc + ' Showroom');
      $lightbox.find('.manager').text('Our manager ' + manager + ' will be in touch.');
    }
  }
  if (type == 'gallery') {
    var $lightbox = $('.lightbox-overlay[data-lightbox-type="gallery"]');
    $lightbox.find('span.title').text($(this).data('title'));
    $lightbox.find('span.project').text($(this).data('project'));
    $lightbox.find('p.designer').text($(this).data('designer'));
    $lightbox.find('.gallery-img').css('background-image', 'url(' + $(this).data('image') + ')');
    $lightbox.find('.gallery-img').css('background-position', $(this).data('focus')); 
    var products = $(this).find('.gallery-product');
    products.each(function() {
      $lightbox.find('.products').append('<div class="product"><a class="v-flex" href="' + $(this).data('link') + '"><div class="product-img" style="background-image: url(' + $(this).data('image') + ');"></div><p><small><strong>' + $(this).data('title') + '</strong><br/>' + $(this).data('vendor') + '</small></p></a></div>');
    });
  }
  if (type == 'surface') {
    var $lightbox = $('.lightbox-overlay[data-lightbox-type="surface"]');
    $lightbox.find('h2').text($(this).data('surface'));
    $lightbox.find('span.vendor').text($(this).data('vendor'));
    $lightbox.find('.img').css('background-image', 'url(' + $(this).data('image') + ')');
  }
  toggleLightbox(e, type);
});
$('a[href="#estimate"], .template-landing header .menu-right .button').on('click', function(e) {
  e.preventDefault();
  toggleLightbox(e, 'estimate');
});
// close
$('.lightbox .x').on('click',function(e, type){
  var type = $(this).parent().parent().data('lightbox-type');
  toggleLightbox(e, type);
  if (type == 'gallery') {
    var $lightbox = $('.lightbox-overlay[data-lightbox-type="gallery"]');
    $lightbox.find('span.title').text('');
    $lightbox.find('span.project').text('');
    $lightbox.find('p.designer').text('');
    $lightbox.find('.gallery-img').css('background-image', 'none'); 
    $lightbox.find('.products').html('');
    console.log('products cleared');
  }
});
// click
$('.lightbox-overlay').on('click', function(e, type) {
  if (e.target === this) {
    var type = $(this).data('lightbox-type');
    toggleLightbox(e, type);
    if (type == 'gallery') {
      var $lightbox = $('.lightbox-overlay[data-lightbox-type="gallery"]');
      $lightbox.find('span.title').text('');
      $lightbox.find('span.project').text('');
      $lightbox.find('p.designer').text('');
      $lightbox.find('.gallery-img').css('background-image', 'none'); 
      $lightbox.find('.products').html('');
      console.log('products cleared');
    }
  }
}).children().click(function(e) {
  console.log($(e.target).closest('a').prop('tagName') == 'A');
  if ($(e.target).is('button') || $(e.target).is('.button') || $(e.target).is('select') || $(e.target).is('input') || $(e.target).is('.checkbox-label') || $(e.target).is('a') || $(e.target).closest('a').prop('tagName') == 'A') {
    return true;
  } else {
    return false;
  }
});
// surfaces
function lightboxSurface() {
  $('.lightbox-overlay[data-lightbox-type="surface"]:not(:first)').remove(); 
}
 
// Expands
$(document).on('click', '.expand-btn', function() {
  if ($(this).hasClass('gallery-filter-cat')) {
    $('.gallery-filter-cat').not($(this)).removeClass('expanded');
  }
  if ($(this).parent().hasClass('location')) { 
    $('.map-nav .location .expand-btn').not($(this)).removeClass('expanded');
  }
  $(this).toggleClass('expanded'); 
}).on('click', '.gallery-filter-options', function(e) {
  e.stopPropagation();
});




// Document Ready
$( document ).ready(function() {
  centerNav();
  lightboxSurface();
  scrollGallery();
});




// Custom Events
if (window.location.pathname.includes('thank-you')) {
  Shopify.analytics.publish('generate_lead');
  gtag('event', 'generate_lead');
  console.log('Generate Lead Event')
}
document.addEventListener('DOMContentLoaded', function() {
    document.body.addEventListener('click', function(event) {
        if (event.target.tagName.toLowerCase() === 'a' && event.target.href.includes('tel')) {
            Shopify.analytics.publish('phone_call');
            gtag('event', 'phone_call', { 
              'phone_number': event.target.getAttribute('href'),
              'page_location': window.location.href,
              'transport_type': 'beacon', // Optional, for reliable tracking
              'outbound': true // Optional
            });
            console.log('Phone Call Event')
        }
    });
}); 

// Capture gclid and populate hidden form field
// Function to get query parameter by name
function getQueryParameterByName(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

// Function to set a cookie
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

// Function to get a cookie by name
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// Function to populate all hidden fields with ID 'hidden-2'
function populateGclidFields() {
  var gclidCookie = getCookie('gclid');
  if (gclidCookie) {
    var gclidFields = document.querySelectorAll('#hidden-2');
    gclidFields.forEach(function(gclidField) {
      gclidField.value = gclidCookie;
    });
  }
}

// Observe DOM changes to handle dynamically added forms
var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      populateGclidFields();
    }
  });
});

// Configuration of the observer
var config = { childList: true, subtree: true };

// Start observing the entire document
observer.observe(document.body, config);

// Get the GCLID from the URL and set the cookie if available
var gclid = getQueryParameterByName('gclid');
if (gclid) {
  setCookie('gclid', gclid, 30); // Store the GCLID for 30 days
}

// Populate the hidden fields on initial load
document.addEventListener('DOMContentLoaded', function() {
  populateGclidFields();
});



